module.exports = __webpack_public_path__ + "img/5.16cf6619.jpg";